"use client"

import styled from "@emotion/styled"
import Container from "@eurodrive/ui/Container"
import { extractProperty } from "@eurodrive/utils"
import { Typography } from "@mui/material"

const StyledContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 40px 0;
  margin: 0 auto;
  max-width: 500px;
  text-align: center;
`

export default function ContentBox({ data }: { data: any }) {
  const title = extractProperty(data, "title")
  const content = extractProperty(data, "content")
  return (
    <Container paddingMobile>
      <StyledContentBox>
        <Typography variant="h2">{title}</Typography>
        <Typography
          component={"div"}
          variant="body2"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </StyledContentBox>
    </Container>
  )
}
